export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-768w.bb359263.png";